import React, { FC } from 'react';
import cs from 'classnames';
import { VIEW_MODE } from '../../utils/helpers';
import s from './templateDemo.scss';
import { templateDemoDataHook } from './TemplateDemo.dataHook';
import { DesktopView } from './DesktopView/DesktopView';
import { MobileView } from './MobileView/MobileView';
import { useTemplateContext } from '../../context/TemplateContext';
import { useUIContext } from '../../context/UIContext';

export const TemplateDemo: FC<{ dataHook?: string }> = ({ dataHook }) => {
  const { viewMode, isInfoShown } = useUIContext();
  const template = useTemplateContext();

  return (
    <div data-hook={dataHook} className={cs(s.demoDisplay, { [s.disabled]: isInfoShown })}>
      {viewMode === VIEW_MODE.DESKTOP ? (
        <DesktopView url={template.publicUrl} title={template.title} dataHook={templateDemoDataHook.desktopView} />
      ) : (
        <MobileView url={template.publicUrl} title={template.title} dataHook={templateDemoDataHook.mobileView} />
      )}
    </div>
  );
};
